// Vendors
import styled from 'styled-components';

const CancelDropModalTitleComponentStyled = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  width: 100%;
`;
CancelDropModalTitleComponentStyled.displayName = 'CancelDropModalTitleComponentStyled';

export { CancelDropModalTitleComponentStyled };
